/* eslint-disable indent */
<template>
    <b-card>
      <!-- for loading page -->
      <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
      <app-confirm :message="'Delete?'" :show="showConfirmBox" @confirmed="confirmedDelete" @cancel="showConfirmBox=false" ></app-confirm>
        <b-card class="card mb-3 mt-3">

          <!-- Name -->
           <b-card no-body class="simple-version-card">
            <b-row>
              <img
              class="thumbnail-size img-fluid img-thumbnail"
              id="iconPreview" @error="altImg"/>
               <div class="simple-appdetail">
                <h3>{{appData.name}}</h3>
              </div>
            </b-row>
          </b-card>
          <b-row>
            <b-col sm="7" md="10"><font class="text"> {{ appData.version }} </font> </b-col>
          </b-row>
          <b-row>
            <b-col sm="7" md="10"><font class="text"> {{ appData.lastModifiedDate }} </font> </b-col>
          </b-row>
          <hr class="my-1"/>
          <b-row>
            <b-col sm="7" md="7">
            <div class="form-group">
              <label for="formGroupExampleInput2">Release notes</label>
              <b-form-textarea
                class="form-control"
                placeholder="Enter release notes"
                rows="3"
                max-rows="8"
                v-model="appData.noteNew"
                :state="validateError.noteNew"
              ></b-form-textarea>
            </div>
            </b-col>
            <b-col>
            <div class="simple-os-right">
              <label class="text compat-label-title">Minimum OS</label>
              <div>{{ appData.compatibility }}</div>
              <div style="">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="usedPin"
                      @change="requestSetPIN"
                      name="checkbox-1"
                    >
                      Use PIN to download
                    </b-form-checkbox>
                      <p v-if="usedPin"> {{pin}} <a @click="requestRandomPIN" href="#">Generate PIN</a> </p>
            </div>
            </div>
            </b-col>
          </b-row>
        </b-card>
        <b-alert class="text-center" :show="errorMessage != ''" variant="danger" dismissible> {{ errorMessage }} </b-alert>
        <b-alert class="text-center" :show="successMessage != ''" variant="success" dismissible> {{ successMessage }} </b-alert>
        <b-card class="save-card">
            <b-button class="mx-1" variant="outline-secondary" @click="$router.go(-1)">Back</b-button>
            <b-button class="mx-1" @click="requestDeleteConfirmBox('version')" variant="outline-danger">Delete</b-button>
            <b-button class="btn-save-simple mx-1"
            @click="save"
            >Save</b-button>
        </b-card>
    </b-card>
</template>
<script>
import Loading from '@/components/Loading';
import ConfirmBox from '@/components/ConfirmBox';
import { dateToStringWithTimeFull } from '@/assets/utils/time.js';

export default {
  data () {
    return {
      newApp: false,
      categories: [{ value: 'Life Style', text: 'Life Style' }, { value: 'Others', text: 'Others' }],
      fileName: '',
      appData: {},
      isEditing: true,
      isCreate: false,
      usedPin: true,
      validateError: {
        noteNew: null
      },
      errorMessage: '',
      successMessage: '',
      delTarget: '',
      isLoading: false,
      showConfirmBox: false,
      pin: 'no pin',
      altImage: require('@/assets/notavailable.png')
    };
  },
  methods: {
    save () {
      this.successMessage = '';
      this.errorMessage = '';
      if (this.isValidateError()) {
        this.errorMessage = 'validate error!';
      } else {
        const formData = new FormData();
        formData.append('noteNew', this.appData.noteNew);
        this.axios.patch(
          process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app/' + this.$route.params.id + '/version/' + this.$route.params.versionid,
          formData)
          .then(response => {
            console.log(response);
            this.successMessage = 'Sucessfully updated.';
          }).catch(error => {
            console.log(error);
            this.errorMessage = 'Error';
          });
      }
    },
    deleteVersion () {
      this.axios.delete(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app/' + this.$route.params.id + '/version/' + this.$route.params.versionid)
        .then(response => {
          console.log(response);
          this.successMessage = 'Sucessfully deleted.';
          this.$router.push({ name: 'apps2-details-2', params: { id: this.$route.params.id } });
        })
        .catch(error => {
          console.log(error);
          this.errorMessage = 'Error';
        });
    },
    altImg (e) {
      e.target.src = this.altImage;
    },
    isValidateError () {
      // eheck object is alive
      if (0 === Object.keys(this.appData).length && this.appData.constructor === Object) return true;

      // start validate field
      if (!this.appData.noteNew || 0 === this.appData.noteNew.length) {
        this.validateError.noteNew = false;
      } else {
        this.validateError.noteNew = null;
      }
      let key = Object.keys(this.validateError).find(k => false === this.validateError[k]);
      return !!key;
    },
    confirmedDelete () {
      this.deleteVersion();
    },
    requestDeleteConfirmBox (t) {
      this.delTarget = t;
      this.showConfirmBox = true;
    },
    requestSetPIN (e) {
      this.isLoading = true;
      const data = { isEnablePIN: e };
      this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/set-enable-pin/' + this.$route.params.id, data)
        .then(response => {
          const data = response.data.data;
          this.pin = data.pin;
        })
        .catch(error => console.log(error))
        .finally(this.isLoading = false);
    },
    requestRandomPIN () {
      this.isLoading = true;
      this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/' + this.$route.params.id + '/random-pin')
        .then(response => {
          const data = response.data.data;
          this.pin = data.pin;
        })
        .catch(error => console.log(error))
        .finally(this.isLoading = false);
    }
  },
  mounted () {
    this.isLoading = true;
    const urlAPI = process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/landing-page/' + this.$route.params.id + '/' + this.$route.params.versionid;
    this.axios.get(urlAPI)
      .then(response => {
        const data = response.data.data;
        this.appData = {
          name: data.app.name,
          version: data.version.version,
          noteNew: data.version.noteNew,
          compatibility: data.version.compatibility,
          isEnablePIN: data.app.isEnablePIN,
          lastModifiedDate: dateToStringWithTimeFull(new Date(data.version.updatedAt))
        };
        this.usedPin = this.appData.isEnablePIN;
        if (this.usedPin) {
          this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/' + this.$route.params.id + '/pin')
            .then(response => {
              const data = response.data.data;
              if (data) {
                this.pin = data.pin;
              }
            })
            .catch(error => console.log(error));
        }
        if (data.version.thumbnail) {
          document.getElementById('iconPreview').src = data.version.thumbnail;
        } else {
          document.getElementById('iconPreview').src = sessionStorage.getItem('appIcon');
        }
      })
      .catch(error => {
        console.log(error);
      })
      .finally(this.isLoading = false);
  },
  watch: {
    // usedPin () {
    //   console.log('change ja');
    // }
  },
  components: {
    'app-loading': Loading,
    'app-confirm': ConfirmBox
  }
};
</script>
<style scoped src="@/assets/css/appstore-simform.css"/>
